import React from 'react';
import { Empty } from 'antd';
import './EmptyState.css';

const EmptyState = ({ description, image }) => {
  return (
    <div className="empty-state-container">
      <Empty
        image={image || Empty.PRESENTED_IMAGE_SIMPLE}
        description={description}
      />
    </div>
  );
};

export default EmptyState;
